import { lazyWithChunkReload } from "../../shared/lib/chunk-load-recovery";

export const AnalyticsDashboardPage = lazyWithChunkReload(() =>
  import("./pages/dashboard.main").then((m) => ({ default: m.AnalyticsDashboardPage }))
);

export const AnalyticsTestDashboardPage = lazyWithChunkReload(() =>
  import("./pages/test-dashboard.main").then((m) => ({ default: m.AnalyticsTestDashboardPage }))
);

export const AnalyticsTestNewDashboardPage = lazyWithChunkReload(() =>
  import("./pages/test-new-dashboard.main").then((m) => ({ default: m.AnalyticsTestNewDashboardPage }))
);
